import React from 'react';
import { Typography } from '@mui/material';
import Navbar from '../Header/Navbar';
import Footer from '../Header/Footer';
import { Stack } from '@mui/system';
import { Circle } from '@mui/icons-material';
import { SectionList } from '../Sections/SectionElements';

const RefundCancellation = () => {
  return (
    <Stack gap={3}>
      <Navbar />

      <Stack sx={{
        width: '100%', alignItems: 'center', boxSizing: 'border-box', p: '20px',
        '& .section': {
          width: '100%', borderRadius: '16px', p: '16px', gap: 2,
          bgcolor: 'var(--color-bg-secondary)',
          boxSizing: 'border-box',
        },

        '& .heading': {
          fontSize: '32px', fontWeight: 'bold', paddingBottom: '4px',
          borderBottom: '1px solid var(--color-border)',
        },

        '& .content': {
          fontSize: '16px', color: 'var(--color-text-secondary)'
        }
      }} >
        <Stack sx={{ width: '100%', maxWidth: '1080px', gap: 3, alignItems: 'flex-start' }} >
          <Stack className='section' style={{ backgroundColor: 'transparent' }} >
            <Typography className='heading' >
              Refund and Cancellation Policy
            </Typography>

            <Stack>
              <Typography className='content' >
                At Optigrit, we strive to provide a seamless and satisfactory experience for all our users. However, we understand that circumstances may arise where a refund or cancellation is necessary.
              </Typography>
            </Stack>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              01 Refunds
            </Typography>

            <SectionList
              icon={<Circle sx={{ fontSize: '10px' }} />}
              list={[
                'We do not offer refunds for subscription fees or usage charges.',
                'Once a payment is made, it is non-refundable, regardless of usage or subscription duration.',
              ]}
              renderItem={item => (
                <Typography className='content' >
                  {item}
                </Typography>
              )}
            />
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              02 Cancellation
            </Typography>

            <SectionList
              icon={<Circle sx={{ fontSize: '10px' }} />}
              list={[
                'You may cancel your subscription at any time through your account settings.',
                'Upon cancellation, your access to the platform and its services will continue until the end of your current billing cycle.',
              ]}
              renderItem={item => (
                <Typography className='content' >
                  {item}
                </Typography>
              )}
            />
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              03 Exceptions
            </Typography>

            <SectionList
              icon={<Circle sx={{ fontSize: '10px' }} />}
              list={[
                'In rare cases of billing errors or discrepancies, please contact our support team at support@optigrit.com for assistance.',
                'Optigrit reserves the right to assess refund requests on a case-by-case basis for exceptional circumstances.',
              ]}
              renderItem={item => (
                <Typography className='content' >
                  {item}
                </Typography>
              )}
            />
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              04 Contact Us
            </Typography>

            <Typography className="content" >
              If you have any questions or concerns regarding refunds or cancellations, please reach out to our dedicated support team at support@optigrit.com. We are here to help and ensure your experience with Optigrit is positive and fulfilling.
            </Typography>
            <Typography className="content" >
              Thank you for choosing Optigrit for your learning content management needs.
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Footer />
    </Stack>
  );
};

export default RefundCancellation;
